import Vue from 'vue';

import DadataVue from './Dadata.vue';

export default function dadataComponent(_Vue: typeof Vue) {
  _Vue.component('AppDadata', DadataVue);
}
